import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import Landing from '@/components/Landing';
import { ThemeProvider, AllThemes } from '2kit';

if (window.__PM) {
	window.__PM.draw();
}

ReactDOM.render(
	<ThemeProvider theme={AllThemes.octavius}>
		<Landing />
	</ThemeProvider>,
	document.getElementById('root'),
);
